import React from "react";
import { Link } from "gatsby";
import { constructUrl } from "../../../utils/constructUrl";
import { getTranslatedCityName } from "../../../utils/getTranslatedCityName";

const InputTableContactUs = ({ text, linkText, pageContext }) => {
	const { city, language, country, hasCityInUrl, isDf, isHomepage } = pageContext;
	let citySlug = hasCityInUrl ? getTranslatedCityName(language, city) : null;
	let countrySlug = isDf ? "df" : isHomepage ? null : country;

	return (
		<div className="flex flex-wrap self-start text-start gap-2 text-sm">
			<p className="text-white">{text}</p>
			<Link
				to={constructUrl(language, countrySlug, citySlug, "/contact-us")}
				className="text-ipxon-magenta font-bold hover:underline transition-all duration-500"
			>
				{linkText}
			</Link>
		</div>
	);
};

export default InputTableContactUs;
